export default __webpack_public_path__ + "static/media/roof-work.2b36973a.webp";